// extracted by mini-css-extract-plugin
module.exports = {"center":"style_center__18Vpn","heading":"style_heading__1ZuDa"};